import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, extensionType } from '@lyearn/lygo-core';

import { CODE_NODE_NAME } from './consts';

export default class Code extends BaseExtension {
  get schema(): MarkSpec {
    return {
      excludes: '_',
      parseDOM: [
        {
          tag: 'code',
          preserveWhitespace: true,
        },
      ],
      toDOM: () => ['code', { class: 'code-01', spellCheck: false }, 0],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return CODE_NODE_NAME;
  }
}
